// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__20vCc","title":"AfterImages90_title__3m8z-","images":"AfterImages90_images__3D80J"};